/* eslint-disable */

import React from "react";
import Header from "./header";

function PageNotFound() {
  return (
    <div className="section">
      <Header />
    </div>
  );
}

export default PageNotFound;
